export const en = {
    no_issues: 'No tickets yet',
};
